export const CHAPTERS_RESET_STATE = 'CHAPTERS_RESET_STATE';
export const CHAPTERS_CURRENT_ITEM = 'CHAPTERS_CURRENT_ITEM';
 
export const CHAPTERS_REQUEST_LOADING = 'CHAPTERS_REQUEST_LOADING';
export const CHAPTERS_REQUEST_SUCCESS = 'CHAPTERS_REQUEST_SUCCESS';
export const CHAPTERS_REQUEST_FAILED = 'CHAPTERS_REQUEST_FAILED';
 
export const CHAPTERS_CURRENT_ACTION = 'CHAPTERS_CURRENT_ACTION';
export const CHAPTERS_RESET_ACTION = 'CHAPTERS_RESET_ACTION';